import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { LOADER_TYPE,SHARED_ACCESS, PEEKABOO_ERROR_MSG } from 'src/app/models/Constants';
import { CustomerAccountBusinessLogicService } from 'src/app/services/customer-account-business-logic.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../../models/Constants';
import { MatDialog } from '@angular/material/dialog';
import _ from 'lodash';


@Component({
  selector: 'app-peekaboo-modal',
  templateUrl: './peekaboo-modal.component.html',
  styleUrls: ['./peekaboo-modal.component.scss'],
})
export class PeekabooModalComponent implements OnInit {
  iconConfig: any;
  showContent: boolean = false;
  methodInstruction: boolean = true;
  expandedIndexEvents: number| null = null;
  expandedMenuId: any ;
  constructor(
    public rootScope: RootScopeService,
    public custAccService: CustomerAccountBusinessLogicService,
    public dialog: MatDialog,

  ) {
    this.iconConfig = {
      iconName: 'times',
      iconType: 'fal',
    };
  }
  peekabooErrorMsg = PEEKABOO_ERROR_MSG;
  peekabooForm: FormGroup = new FormGroup({ topic: new FormControl('') });
  domains: any = [];
  idMappingDomains: any = [];
  domainLabels = Constants.TBA_DOMAIN_Lables;
  kcPortalForm: FormGroup = new FormGroup({ kcPortal: new FormControl('') });
  kcPortalListData: any = [];
  filteredlinksSectionData: any = [];
  linksSectionData: any = [];
  topicListByDomainError: boolean = false;
  domainTopicsLinksSectionsError: boolean = false;
  showRefreshIcon: boolean = false;
  showRefreshIconForLinksSectionsError: boolean = false;
  loaderType = LOADER_TYPE.CARD;
  showPeekabooLoader: boolean = false;
  showPeekabooLoaderMsg: boolean = false;
  peekabooLoaderTimeoutId: any;
  sharedAccess= SHARED_ACCESS;
  


  ngOnInit(): void {
    this.getDomainTopics();
    this.getDomain();
  }

  /** Method to get domain topics from the server or cache if available.*/
  getDomainTopics() {
    this.topicListByDomainError = false;
    this.domainTopicsLinksSectionsError = false;
    this.showRefreshIcon = false;
    this.showRefreshIconForLinksSectionsError = false;
    const cachedDomainTopics = this.rootScope.activeCustTab.domainsTopics?.find(item => item?.domainId === this.rootScope.activeCustTab.domainIndex?.domainName);
    if (cachedDomainTopics) {
      this.domains = cachedDomainTopics?.topicsData;
      this.peekabooForm.get('topic')?.setValue(cachedDomainTopics?.selectedTopic);
      this.kcPortalForm.get('kcPortal')?.setValue(cachedDomainTopics?.selectedPortal);
      this.getDomainTopicsLinksSections();
    } else {
      this.getTopicListByDomain(this.rootScope.activeCustTab.clientId, this.rootScope.activeCustTab.domainIndex?.domainName);
    }
  }

  /** Method to fetch topic list by domain from the server and handle the response.*/
  getTopicListByDomain(clientId, domainId) {
    this.startTimerForLoader();
    this.custAccService.getTopicListByDomain(clientId, domainId).subscribe({
      next: (res: any) => {
        clearTimeout(this.peekabooLoaderTimeoutId);
        this.showPeekabooLoader = false;
        this.showPeekabooLoaderMsg = false;
        const sortedTopics = res?.data?.topics.sort((a, b) => a?.topicLabel?.localeCompare(b?.topicLabel));
        const obj = {
          domainId: this.rootScope.activeCustTab.domainIndex?.domainName,
          topicsData: sortedTopics,
          selectedTopic: sortedTopics[0].topicId,
          topicsLinksSectionData: []
        }
        this.rootScope.activeCustTab.domainsTopics.push(obj);
        this.domains = sortedTopics;
        this.peekabooForm.get('topic')?.setValue(sortedTopics[0]?.topicId);
        this.getDomainTopicsLinksSections();
      },
      error: (err: HttpErrorResponse) => {
        console.log(err);
        clearTimeout(this.peekabooLoaderTimeoutId);
        this.showPeekabooLoader = false;
        this.showPeekabooLoaderMsg = false;
        this.topicListByDomainError = true;
        if (err.status == 404) {
          const errorCodePrefix = err?.error?.errorResponse?.message;
          this.peekabooErrorMsg = `${errorCodePrefix}: No topics found. There was a problem loading the data.`;

        } else {
          this.peekabooErrorMsg = PEEKABOO_ERROR_MSG;
          this.showRefreshIcon = true;
        }
      }
    })
  }

  /** Method to handle the selection of a topic from the UI.*/
  selectedTopic(event: { value: any }) {
    this.showRefreshIconForLinksSectionsError = false;
    const cachedDomainTopics = this.rootScope.activeCustTab.domainsTopics.find(
      item => item.domainId === this.rootScope.activeCustTab.domainIndex?.domainName);
    if (cachedDomainTopics) {
      cachedDomainTopics.selectedTopic = event?.value;  
      this.kcPortalForm.get('kcPortal')?.setValue('Show All');
      this.getDomainTopicsLinksSections();
    }
  }


  getLabel(domain:any){
      if(domain?.includes(",")){
        let arr = domain?.split(",");
        const converted = arr.map((code: any)  =>  Constants.TBA_DOMAIN_Lables[code]);
        const result = converted.join(', ');
        return result;
      }
      else{
        return Constants.TBA_DOMAIN_Lables[domain];
      }
  }

    
  /**
   * Updates the selected portal and filters the Knowledge Center portal links accordingly.
   * 
   * @param event The event containing the selected portal value.
   */
  selectedPortal(event) { 
    this.showRefreshIconForLinksSectionsError = false;
    const cachedDomainTopics = this.rootScope.activeCustTab.domainsTopics.find(
      item => item.domainId === this.rootScope.activeCustTab.domainIndex?.domainName);
    if (cachedDomainTopics) {
      cachedDomainTopics.selectedPortal = event?.value;
    }
    this.filterKCPortalLinks();
  }

  /*Retrieves links sections data for the selected domain and topic, either from cache or by fetching from the server.
   * If cached data is available, it populates the links section data with it. Otherwise, it fetches data from the server.*/
  getDomainTopicsLinksSections() {
    this.domainTopicsLinksSectionsError = false;
    this.showRefreshIconForLinksSectionsError = false;
    const activeTab = this.rootScope.activeCustTab;
    const selectedDomainName = activeTab.domainIndex?.domainName;
    const cachedDomainTopics = activeTab.domainsTopics?.find(item => item?.domainId === selectedDomainName);
    if (cachedDomainTopics) {
      const cachedLinksSection = cachedDomainTopics?.topicsLinksSectionData.find(item => item?.topicId === cachedDomainTopics?.selectedTopic);
      if (cachedLinksSection) {
        this.linksSectionData = cachedLinksSection?.linksSectionsData;
        this.kcPortalForClientDomain();
        this.checkedSectionNotload(cachedLinksSection?.linksSectionsData);
      } else {
        this.getTbaKcArticleLinks(
          this.rootScope.activeCustTab.clientId,
          this.rootScope.activeCustTab.domainIndex?.domainName,
          cachedDomainTopics.selectedTopic
        );
      }
    }
  }

  /**
   * Retrieves KC article and TBA links for the specified client, domain, and topic, populating the links section data.
   * @param {string} clientId - The ID of the client for which to fetch the article links.
   * @param {string} domainId - The ID of the domain within the client's context.
   * @param {string} topicId - The ID of the topic for which to retrieve article links.
   */
  getTbaKcArticleLinks(clientId, domainId, topicId) {
    this.startTimerForLoader();
    this.custAccService.getTbaKcArticleLinks(clientId, domainId, topicId).subscribe({
      next: (res: any) => {
        clearTimeout(this.peekabooLoaderTimeoutId);
        this.showPeekabooLoader = false;
        this.showPeekabooLoaderMsg = false;
        this.checkedSectionNotload(res?.data?.menuList);
        console.log('peekaboo links section data  : ' + JSON.stringify(res));
        const linksSections = res?.data?.menuList?.map(section => ({
          ...section,
          showMore: false,
          slicedSubMenuList: this.maxItems(section),
        }));
        this.linksSectionData = linksSections;
        this.kcPortalForClientDomain();
        this.kcPortalForm.get('kcPortal')?.setValue(this.kcPortalListData[0]?.fieldValue);

        let obj = {
          topicId: topicId,
          linksSectionsData: linksSections,
        }
        const cachedDomainTopics = this.rootScope.activeCustTab?.domainsTopics?.find(
          item => item?.domainId === this.rootScope.activeCustTab?.domainIndex?.domainName);
        if (cachedDomainTopics) {
          cachedDomainTopics?.topicsLinksSectionData?.push(obj);
          cachedDomainTopics.selectedPortal = this.kcPortalListData[0]?.fieldValue;

        }
      },
      error: (err) => {
        console.log('peekaboo links section data  error : ' + JSON.stringify(err));
        clearTimeout(this.peekabooLoaderTimeoutId);
        this.showPeekabooLoader = false;
        this.showPeekabooLoaderMsg = false;
        this.peekabooErrorMsg = PEEKABOO_ERROR_MSG;
        this.domainTopicsLinksSectionsError = true;

      }
    })
  }

  /**
 * @param {any} section - The section object containing heading and sub-menu information.
 * @returns {number} The maximum number of items to display in the given section.
 */
  maxItems(section: any): number {
    const heading = section?.heading;
    const subMenuLength = section?.subMenuList?.length;
    switch (heading) {
      case "Knowledge Articles":
        return Math.min(subMenuLength > 6 ? 6 : subMenuLength);
      case "TBA Events":
        return Math.min(subMenuLength > 5 ? 5 : subMenuLength);
      case "TBA Inquiries":
        return Math.min(subMenuLength > 5 ? 5 : subMenuLength);
      default:
        return Math.min(5);
    }
  }

  /**
 * Checks if any menu section is marked as not loaded (null ID) and triggers a visual indication if found.
 * If a menu section with null ID is present, it sets a flag to display a refresh icon for links sections error.
 * @param {any[]} menuList - The list of menu sections to be checked.
 */
  checkedSectionNotload(menuList: any) {
    const checkedSectionNotload = menuList?.find(
      item => item?.id === null);
    if (checkedSectionNotload) {
      this.showRefreshIconForLinksSectionsError = true;
    }
  }

  /**
   * Refreshes the links section for the selected topic by fetching updated knowledge base article links.
   * Clears existing data and reloads the links section with the latest information.
   * Also handles the removal of the currently selected topic's link data from the cached domain topics.
   */
  refreshSelectedTopicLinks() {
    this.showRefreshIconForLinksSectionsError = false;
    this.linksSectionData = [];
    this.kcPortalListData = [];
    this.filteredlinksSectionData = [];
    const activeTab = this.rootScope.activeCustTab;
    const selectedDomainName = activeTab.domainIndex?.domainName;
    const cachedDomainTopics = activeTab.domainsTopics?.find(item => item?.domainId === selectedDomainName);
    if (cachedDomainTopics) {
      cachedDomainTopics.topicsLinksSectionData = cachedDomainTopics?.topicsLinksSectionData?.filter(item => item?.topicId !== cachedDomainTopics?.selectedTopic);
    }
    this.getTbaKcArticleLinks(
      this.rootScope.activeCustTab.clientId,
      this.rootScope.activeCustTab.domainIndex?.domainName,
      cachedDomainTopics.selectedTopic
    );
  }


  /**
 * Starts a timer to display the Peekaboo loader and shows a loader message after a specified duration.
 * The duration is calculated based on the `rootScope.showLoaderMsgThreshold` value.
 * The loader message will be shown after the calculated duration in seconds.
 */
  startTimerForLoader() {
    this.showPeekabooLoader = true;
    const durationInSeconds = 1 * this.rootScope.showLoaderMsgThreshold;
    const durationInMilliseconds = durationInSeconds * 1000;
    /*istanbul ignore next */
    this.peekabooLoaderTimeoutId = setTimeout(() => {
      this.showPeekabooLoaderMsg = true;
    }, durationInMilliseconds);
  }

/**
 * disabledTBALinks() -added method to disable TBA Event and TBA Inquiry links
 * param1 - passing peekaboo child link
 * @author Amarjeet
 */
  disabledTBALinks(subMenu){
  if(this.rootScope.activeCustTab?.defaultRole==this.sharedAccess && subMenu?.link?.linkType=='TBA')
    return true;
  else return false;
  }

  
  /**
   * Retrieves and filters Knowledge Articles portal data based on the client domain.
   */
  kcPortalForClientDomain() {
    const kcPortalData = this.linksSectionData?.find((x: any) => x?.heading === 'Knowledge Articles');
    
    if (kcPortalData) {
      this.kcPortalListData = this.rootScope.kcPortalList?.filter((kcPortal: any) => {
        return kcPortalData?.subMenuList?.some((subMenu: any) => {
          return subMenu?.link?.linkPropertiesValues?.includes(kcPortal?.fieldValue);
        });
      });
    }

    this.kcPortalListData = this.kcPortalListData?.sort((a: any, b: any) => {
      return parseFloat(a?.sequence) - parseFloat(b?.sequence);
    });

    this.kcPortalListData.unshift({
      "fieldKey": "KC-portal-list",
      "fieldValue": "Show All",
      "fieldValueDescription": "Show All",
      "sequence": "10.00"
    });
    
    this.filterKCPortalLinks();

  }

  /**
   * Filters the links in the Knowledge Articles section based on the selected portal.
   */
  filterKCPortalLinks() {
    const selectedPortal = this.kcPortalForm.get('kcPortal')?.value;

    const kcPortalData = this.linksSectionData?.filter((x: any) => x?.heading === 'Knowledge Articles');

    if (selectedPortal == 'Show All') {
      this.filteredlinksSectionData = kcPortalData;
    } else {
      if (kcPortalData) {
        let filterSubMenu = kcPortalData.flatMap((section: any) =>
          section?.subMenuList?.filter((subMenu: any) =>
            subMenu?.link?.linkPropertiesValues?.includes(selectedPortal)
          )
        );
        this.filteredlinksSectionData = kcPortalData?.map((section: any) => ({
          ...section,
          subMenuList: section?.subMenuList?.filter((subMenu: any) =>
            filterSubMenu?.some((item: any) => item?.link?.linkPropertiesValues?.includes(subMenu?.link?.linkPropertiesValues))
          )
        }));
      }
    }

  }


  /**
   * Opens the TBA link for the specified menu and sets the domain if provided.
   * @param menu - The menu object that contains the link to be opened.
   * @param domain - The domain to be associated with the menu. If not provided, the menu's domain will remain unchanged.
   */
  openTBALink(menu: any, domain: any) {
    if (domain) {
      menu.domain = domain; 
    }
    this.rootScope.selectedLeftNavBarLink(menu, true);
  }

  /******
   * * Below piece of code added to handle if idMapping have multiple entry of 
      same domain Names, It should be considered as single entry CCR1-10675  /CCr1-11324
      **********/
           
  openTBAInCaseOfSingleDomain(menu:any){

    const filteredMappings = this.rootScope.activeCustTab.tabData.tabData.idMapping.
              filter((mapping:any) => mapping.platformType.includes('TBA'));
            
    let domainList = _.map(filteredMappings, item => item?.domains);
    domainList = Array.from(new Set(domainList));  /**Remove duplicate values */
    if(domainList && domainList.length > 0){
      menu.domain = domainList[0];
     }
    this.rootScope.selectedLeftNavBarLink(menu, true);
  }

  


  /**
   * Retrieves the domains associated with the 'TBA' platform type from the active customer's tab data.
   * If domains are found, they are split by commas and pushed into the `idMappingDomains` array.
   */
  getDomain() {

    const idMapping = this.rootScope?.activeCustTab?.tabData?.tabData?.idMapping;
    if (!idMapping) {
      console.error('idMapping is undefined or null');
      return;
    }

    const filteredMappings = idMapping?.filter(mapping => mapping?.platformType?.includes('TBA'));

    if (filteredMappings?.length > 1) {
      const domains: string[] = [];
      for (const mapping of filteredMappings) {
        if (mapping?.domains) {
          // if (mapping.domains?.includes(',')) {
          //   const splitDomains = mapping?.domains?.split(',');
          //   domains.push(...splitDomains);
          // } else {
            domains.push(mapping?.domains);
          // }
        }
      }
      this.idMappingDomains = Array.from(new Set(domains));
      console.log('domains', this.idMappingDomains);
    }
  }



  /**
   * Opens the panel for the specified index and sets the expanded menu ID.
   * @param index - The index of the panel to be opened.
   * @param id - The identifier for the expanded menu.
   */
  openPanelClosed(index: number, id: any) {
    this.expandedMenuId = id;
    this.expandedIndexEvents = index;

  }
 


}
